import React from "react";
import { Briefcase, Users, Cpu, ChartBar, Scale, Heart, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  title: "Entrepreneurship & Economic Development",
  icon: Briefcase,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1208726/img/entrepreneur_meeting_modern_office.png",
  mission: "Fueling business growth and economic resilience through strategic support.",
  link: "#"
}, {
  title: "Leadership Development",
  icon: Users,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1208726/img/leadership_seminar_speaker.png",
  mission: "Cultivating the next generation of visionary leaders for Colorado.",
  link: "#"
}, {
  title: "Workforce & Innovation",
  icon: Cpu,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1208726/img/tech_hub_innovation_lab.png",
  mission: "Bridging talent gaps with future-ready skills and technological adoption.",
  link: "#"
}, {
  title: "Data & Research",
  icon: ChartBar,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1208726/img/data_analytics_dashboard_screen.png",
  mission: "Driving decisions with actionable intelligence and demographic insights.",
  link: "/IntelligencePage"
}, {
  title: "Policy & Advocacy",
  icon: Scale,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1208726/img/capitol_building_advocacy.png",
  mission: "Championing policies that empower the Hispanic business community.",
  link: "#"
}, {
  title: "Community & Cultural Programs",
  icon: Heart,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1208726/img/cultural_festival_community_event.png",
  mission: "Celebrating heritage and strengthening bonds across the state.",
  link: "#"
}];
export default function PillarsOfProsperity() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="pillars-of-prosperity" ref={ref} className={`dark bg-background text-foreground py-24 px-4 md:px-8 transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">
            Core Pillars of Impact
          </h2>
          <p className="text-muted-foreground text-lg">
            Our strategic framework designed to drive economic growth, equity, and innovation for Colorado's Hispanic community.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {pillars.map((pillar, i) => <Link key={i} to={pillar.link} className="block h-full" data-index={i}>
              <Card className="group relative h-80 w-full overflow-hidden border-border/50 bg-card hover:border-primary/50 transition-colors duration-500">
                {}
                <div className="absolute inset-0 z-0">
                  <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110 opacity-0 group-hover:opacity-100" style={{
                backgroundImage: `url(${pillar.image})`
              }} />
                  {}
                  <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>

                {}
                <div className="relative z-10 flex flex-col justify-between h-full p-8">
                  {}
                  <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary group-hover:bg-white/20 group-hover:text-white transition-colors duration-300">
                    <pillar.icon strokeWidth={1.5} className="w-6 h-6" />
                  </div>

                  {}
                  <div className="mt-auto transform transition-transform duration-500 group-hover:-translate-y-2">
                    <h3 className="text-xl font-semibold mb-2 text-card-foreground group-hover:text-white transition-colors duration-300">
                      {pillar.title}
                    </h3>
                    
                    <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-[grid-template-rows] duration-500 ease-out">
                      <div className="overflow-hidden">
                        <p className="text-sm text-gray-200 mb-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
                          {pillar.mission}
                        </p>
                        <div className="flex items-center text-sm font-medium text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-200">
                          Learn More <ArrowRight className="ml-2 w-4 h-4" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}